<template>
	<div :class="{ loader: true, fadeout: !isLoading }" v-if="this.language == 'en'">
		<div class="fixed left-0 right-0 top-2/6">
			<img class="mx-auto" src="../assets/images/freshest-flick-malay.png" alt="">
		</div>
	</div>
	<div :class="{ loader: true, fadeout: !isLoadingThai }" v-else>
		<div class="fixed left-0 right-0 top-2/6">
			<img class="mx-auto" src="../assets/images/freshest-flick-thai.png" alt="">
		</div>
	</div>
</template>

<style scoped>
	.loader {
		background-image: url('../assets/images/screen-homepage.jpg');
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		bottom: 0;
		display: block;
		left: 0;
		overflow: hidden;
		position: fixed;
		right: 0;
		top: 0;
	}

	.fadeout {
		animation: fadeout 2s forwards;
	}

		@keyframes fadeout {
		to {
			opacity: 0;
			visibility: hidden;
		}
	}
</style>

<script>
export default {
	name: 'LoadingScreen',
	props: [
		'isLoading',
		'isLoadingThai'
	],

	data() {
		return {
			language: '',
		}
	},

	mounted () {
		this.language = process.env.VUE_APP_I18N_LOCALE
		console.log(this.language)
	}
}
</script>
